module.exports = __webpack_public_path__ + "media/images/lb/570-5d05d2a2b878b8b44e8ded02dde636f8.svg";